import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";
import { persistPromoSimulatorSlice } from "./promoSimulatorPersist";

const store = configureStore({
  reducer: rootReducer, // equivalent to the rootReducer
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // Add thunk if you need it
  devTools: process.env.REACT_APP_NODE_ENV !== "production", // Use REACT_APP_NODE_ENV for Webpack bundling
});

let lastPromoPersistJson = "";
store.subscribe(() => {
  try {
    const ps = store.getState().promoSimulator;
    const snapshot = JSON.stringify({
      scenarios: ps.scenarios,
      activeScenarioId: ps.activeScenarioId,
      selectedSKUs: ps.selectedSKUs,
      selectedWeekStart: ps.selectedWeekStart,
      selectedWeekEnd: ps.selectedWeekEnd,
      discountPct: ps.discountPct,
      selectedManufacturer: ps.selectedManufacturer,
      selectedClass: ps.selectedClass,
    });
    if (snapshot === lastPromoPersistJson) return;
    lastPromoPersistJson = snapshot;
    persistPromoSimulatorSlice(ps);
  } catch {
    /* ignore */
  }
});

export default store;
